export const TITULO = "Criar nova versão";
export const ETAPAS_LABEL = "Etapas da nova versão";
export const ETAPA_CORRECAO = "Correção";
export const ETAPA_CONFIRMACAO = "Confirmação";

export const CANCELAR_LABEL = "Cancelar";
export const VOLTAR_LABEL = "Voltar";
export const PROXIMA_LABEL = "Próxima etapa";
export const CRIAR_LABEL = "Criar nova versão";

export const CARREGANDO_LABEL = "Carregando a próxima versão...";

export const INTRODUCAO =
  "A nova versão começa como uma cópia da versão mais recente. Se os custos mudaram de forma geral, informe a correção; os ajustes de cada escopo ficam para depois.";
export const ORIGEM_LEGENDA = "Continua disponível para consulta no seletor de ano.";
export const DESTINO_LEGENDA = "Abre em seguida, pronta para revisar.";
export const ORIGEM_ROTULO = "Versão de origem";
export const DESTINO_ROTULO = "Nova versão";

export const PERCENTUAL_AJUDA =
  "Aplicada aos custos de todos os escopos copiados. As horas não mudam. Aceita valor negativo.";
export const PERCENTUAL_PADRAO = "0,00";
export const MSG_PERCENTUAL_INVALIDO =
  "Informe um percentual maior que -100, com até 4 casas decimais.";

export const COPIADO_TITULO = (destino: string) => `O que vai para a ${destino}`;
export const COPIADO_ESCOPOS_EQUIPAMENTO =
  "Escopos de equipamento, com as horas de revisão de cada periodicidade";
export const COPIADO_ESCOPOS_CLASSE_OUTROS = "Escopos de classe e escopos do grupo Outros";
export const COPIADO_CUSTOS = "Custos de Serviços e de Materiais, cada um com a sua moeda";
export const COPIADO_SEM_CORRECAO = "Sem correção: os custos vão com os mesmos valores";
export const COPIADO_COM_CORRECAO = (correcao: string) =>
  `Correção de ${correcao}; as horas de revisão não mudam`;
export const ESCOPOS_A_COPIAR = (n: number) =>
  n === 1 ? "1 escopo macro será copiado." : `${n} escopos macro serão copiados.`;

export const MS11 = (origem: string, destino: string, correcao: string | null) =>
  `Os escopos macro, as horas e os custos padrão da ${origem} serão copiados para a ${destino}, ${
    correcao === null ? "sem correção" : `com correção de ${correcao}`
  }. Depois, você revisa os valores um a um.`;
